import axios from "axios";

const GetPaymentHistory = {
    getByCarrierId(carrierId) {
        return axios.get(
            `https://api.shippersedge.com/carrierportal/paymentHistory/${carrierId}`,
            { headers: { "x-api-key": "vdhy8wwjUJrwhxFpfuECTiAW" } }
        );
    }
};

export default GetPaymentHistory;
